import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { DataForDisplayingMenuItemsService } from '../services/data-for-displaying-menu-items.service';
import { ProjectManagerService } from '../services/project-manager.service';
import { HandrailDisplayService } from '../services/handrail-display.service';

@Component({
  selector: 'app-add-stair-handrail',
  templateUrl: './add-stair-handrail.component.html',
  styleUrls: ['./add-stair-handrail.component.scss']
})
export class AddStairHandrailComponent implements OnInit {

  top150Rail: boolean = false;
  appliedHandrail: boolean = false;
  remove: boolean = false;

  railingType: string = '';
  projectType: string = '';
  topRail: string = '';
  railingHeight: string = '';

  selectedHandrail = {
    top150Rail: false,
    appliedHandrail: false
  };

  conditionsForTop150: Array<any> = [
    {
      projectType: ['home'],
      railingType : ['DesignRail'],
      railingHeight: ['36', '38', '42']
    }
  ];

  conditionsForApplied: Array<any> = [
    {
      projectType: ['home'],
      railingType : ['DesignRail'],
      railingHeight: ['38', '42']
    },
    {
      projectType: ['business'],
      railingType : ['DesignRail'],
      railingHeight: ['42']
    }
  ];

  railingTypes;

  @Output() step2Editer = new EventEmitter();

  goBack(value) {
    this.step2Editer.emit({ name: value });
  }

  constructor(
    public dataForMenu: DataForDisplayingMenuItemsService,
    public projectSrvc: ProjectManagerService,
    private handrailDisplayService: HandrailDisplayService
  ) {
    this.handrailDisplayService.needHandrailChange.subscribe(value => {
      if (value) {
        this.setVisibleContent();
        if(this.selectedHandrail.appliedHandrail||this.selectedHandrail.top150Rail){
          this.handrailDisplayService.handrailSubj.next(true)
        }
      } else {
        this.top150Rail = false;
        this.appliedHandrail = false;
        this.remove = false;
        this.handrailDisplayService.handrailSubj.next(false)
      }
    });

    this.dataForMenu.stairHandrail.subscribe(value => this.setSelectedSettings(value));
  }

  setVisibleContent() {
    const params = [this.projectType, this.railingType, this.railingHeight];
    const existingParamsTop150Rail = [];
    const existingParamsAppliedHandrail = []
    params.forEach(element => {
      if (element) {
        existingParamsTop150Rail.push(element);
        existingParamsAppliedHandrail.push(element);
      }
    });

    this.top150Rail = this.conditionsForTop150.some(condition => {
      const apply = existingParamsTop150Rail.every(cond => {
        let anyOverlap = false;
        for (const state in condition) {
          if (condition[state].includes(cond)) {
            anyOverlap = true;
          }
        }
        return anyOverlap;
      });

      return apply;

    });

    this.appliedHandrail = this.conditionsForApplied.some(condition => {
      const apply = existingParamsAppliedHandrail.every(cond => {
        let anyOverlap = false;
        for (const state in condition) {
          if (condition[state].includes(cond)) {
            anyOverlap = true;
          }
        }
        return anyOverlap;
      });

      return apply;

    });

    //this.top150Rail = this.railingHeight==='36' && this.topRail === '150s' ? false : this.top150Rail;
    this.appliedHandrail = (this.railingHeight==='36' || this.railingHeight==='38') && this.topRail === '150s' ? false : this.appliedHandrail;
    this.remove = (this.projectType!=='business'&&(this.appliedHandrail||this.top150Rail)) && !(this.topRail === '150s'&&this.railingHeight==='36') ? true : false;

    if(!(this.appliedHandrail && this.top150Rail)){
      this.handrailDisplayService.handrailSubj.next(false)
    }

  }

  setStairHandrail(value: string) {
    this.dataForMenu.setStairHandrail(value);
  }

  ngOnInit() {
    const params = this.dataForMenu.getCurrentParams();
    if (params.stairHandrail.includes('150')) {
      this.selectedHandrail.top150Rail = true;
      this.setStairHandrail('top150');
    }
    if (params.stairHandrail.includes('applied')) {
      this.selectedHandrail.appliedHandrail = true;
      this.setStairHandrail('appliedHandrail');
    }
    this.dataForMenu.railingType.subscribe(value => {
      this.railingType = value;
      if (!value) {
        this.railingType = params.railingType;
      }
      this.projectType = this.projectSrvc.getProjectType();
      this.setVisibleContent();
    });

    this.dataForMenu.topRail.subscribe(value => {
      this.topRail = value;
      if (!value) {
        this.topRail = params.topRail;
      }
      this.setVisibleContent();
    });

    this.dataForMenu.railingHeight.subscribe(value => {
      this.railingHeight = value;
      if (!value) {
        this.railingHeight = params.railingHeight;
      }
      this.setVisibleContent();
    });

    // this.projectSrvc.projectNewChanges.subscribe(value => {
    //   this.projectType = value;
    //   this.setVisibleContent();
    // });
  }

  setSelectedSettings(value) {
    switch (value) {
      case 'top150': {
        this.clearSelection();
        this.selectedHandrail.top150Rail = true;
        this.handrailDisplayService.handrailSubj.next(true)
        break;
      }
      case 'appliedHandrail': {
        this.clearSelection();
        this.selectedHandrail.appliedHandrail = true;
        this.handrailDisplayService.handrailSubj.next(true)
        break;
      }
      default: {
        this.clearSelection();
      }
    }
  }

  clearSelection() {
    this.selectedHandrail = {
      top150Rail: false,
      appliedHandrail: false
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/add-stair-handrail/add-stair-handrail.component.ts